import React from 'react';
import './NavItem.scss';
import { shouldShowMenuItem } from '../utils/menuVisibility';
import { useLocation } from 'react-router-dom';

interface NavItemProps {
    href?: string;
    label: string;
    dropdownItems?: Array<{
        href: string;
        label: string;
        target?: string;
        displayFor?: string[];
    }>;
    className?: string;
    buttonClass?: string;
    onClick?: () => void;
    displayFor?: string[];
    cust_type?: string;
}

const NavItem: React.FC<NavItemProps> = ({ 
    href = '#', 
    label, 
    dropdownItems, 
    className = '',
    buttonClass = '',
    onClick,
    displayFor,
    cust_type = 'not-logged-in'
}) => {
    const location = useLocation();
    const currentPath = location.pathname.replace(/\/$/, '') || '/';

    // Helper to check if a link is active
    const isActiveLink = (path?: string) => {
        if (!path || path === '#' || path.startsWith('javascript:')) return false;
        
        try {
            // Check if it's an absolute URL
            const isAbsolute = path.startsWith('http');
            const url = isAbsolute ? new URL(path) : new URL(path, window.location.origin);
            
            // If absolute, it must match current origin to be active
            if (isAbsolute && url.origin !== window.location.origin) {
                return false;
            }

            const normalizedPath = url.pathname.replace(/\/$/, '') || '/';
            return currentPath === normalizedPath;
        } catch (e) {
            // Fallback for non-standard paths
            const normalizedPath = path.replace(/\/$/, '') || '/';
            return currentPath === normalizedPath;
        }
    };

    // Filter dropdown items based on customer type
    const filteredDropdownItems = dropdownItems?.filter(item => 
        shouldShowMenuItem(item.displayFor, cust_type)
    );

    const hasVisibleDropdown = filteredDropdownItems && filteredDropdownItems.length > 0;

    // Check if current item or any of its dropdown children is the current page
    const isCurrentPage = isActiveLink(href) || 
        (filteredDropdownItems?.some(item => isActiveLink(item.href)) ?? false);

    return (
        <li className={`nav-item`}>
            <a 
                href={hasVisibleDropdown ? 'javascript:void(0);' : href} 
                onClick={onClick}
                className={`${className} ${hasVisibleDropdown ? 'has-dropdown' : ''} ${isCurrentPage ? 'active' : ''} ${buttonClass}`}
            >
                {label}
            </a>
            {hasVisibleDropdown && (
                <ul className="dropDown">
                    {filteredDropdownItems.map((item, index) => (
                        <li key={index}>
                            <a href={item.href} target={item.target}>{item.label}</a>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};

export default NavItem;
